import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import DownloadMaterialVsAlternatePDF from './DownloadMaterialVsAlternatePDF';
import { DownloadButton } from '../../../../../Components/Utils/Buttons';

function MaterialVsAlternatePDFLink({ data = [], fileName = 'Material_Requested_vs_Alternate.pdf' }) {
  return (
    <PDFDownloadLink
      // document={<DownloadMaterialVsAlternatePDF data={data} date={new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} />}
      fileName={fileName}
    >
      {({ loading }) => (
        <DownloadButton
          label={loading ? 'Generating PDF...' : 'Download PDF'}
          disabled={loading}
        />
      )}
    </PDFDownloadLink>
  );
}

export default MaterialVsAlternatePDFLink;
